import BoqItemsFieldArray from "components/common/BoqItemsFieldArray";
import { QuotationItemType } from "features/Quotations/constants/quotation.constants";
import type { QuotationItemFormRow } from "features/Quotations/utils/quotationItem.utils";

export type PurchaseOrderBoqFieldArrayProps = {
  validation: any;
  readOnly: boolean;
  embedded?: boolean;
};

export function purchaseOrderEmptyBoqRow(): QuotationItemFormRow {
  return {
    type: QuotationItemType.MATERIAL,
    description: "",
    productId: "",
    quantity: 1,
    unit: "",
    rate: 0,
    supplierId: null,
    materialRequestItemId: null,
  };
}

export default function PurchaseOrderBoqFieldArray({
  validation,
  readOnly,
  embedded = true,
}: PurchaseOrderBoqFieldArrayProps) {
  return (
    <BoqItemsFieldArray
      validation={validation}
      readOnly={readOnly}
      embedded={embedded}
      cardTitle="Line items"
      cardSubtitle="Material catalogue lines with quantity, unit, rate, and optional per-line supplier."
      addLineLabel="Add line"
      getDefaultRow={purchaseOrderEmptyBoqRow}
      showSupplierColumn
      supplierColumnEditable
    />
  );
}
